import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button } from "antd";
import { ADD_PRODUCT_FIELDS } from "constants/form-fields";
import { fieldGenerator, getErrorOnField } from "utilities/form";

const FormItem = Form.Item;

class AddProductForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    onSubmit = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            if(!err) {
                this.props.onSubmit(values);
            }
        });
    }
    render() {
        return (
            <Form
                layout="vertical"
                hideRequiredMark={false}
                className={cx("form", "br-3")}>
                <div className={"form-row"}>
                    {ADD_PRODUCT_FIELDS.map((field, fieldName) =>
                        this.fieldGenerator(
                            fieldName,
                            field,
                            this.getErrorOnField(fieldName)
                        )()
                    ).toList()}
                </div>
                <div className="d-flex justify-content-flex-end">
                    <FormItem className={cx("m-0")}>
                        <Button
                            type="primary"
                            onClick={this.onSubmit}
                            icon={"plus"}>
                            Add
                        </Button>
                    </FormItem>
                </div>
            </Form>
        );
    }
}

AddProductForm.propTypes = {
    form: PropTypes.object,
    onSubmit: PropTypes.func
};

export default Form.create({})(AddProductForm);